import { render, staticRenderFns } from "./FreightTableActionsMenu.vue?vue&type=template&id=d35c1c80&scoped=true"
import script from "./FreightTableActionsMenu.vue?vue&type=script&lang=js"
export * from "./FreightTableActionsMenu.vue?vue&type=script&lang=js"
import style0 from "./FreightTableActionsMenu.vue?vue&type=style&index=0&id=d35c1c80&prod&scoped=true&lang=less"
import style1 from "./FreightTableActionsMenu.vue?vue&type=style&index=1&id=d35c1c80&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35c1c80",
  null
  
)

export default component.exports